import React from 'react';
import MatchAnalysis from './MatchAnalysis';

/** Recorded analytics remain usable when the primary match endpoint is unavailable. */
export default function RecordedMatchFallback({enabled,data}) {
 if(!enabled || data?.status!=='AVAILABLE')return null;
 return <section aria-label="Cached match analytics">
  <h1>{data.profile?.name}</h1>
  <p className="fa-note">Showing recorded PitchAPI analytics. Live score, odds and notifications are unavailable here. Retrieved {data.latest_observed_at||'at an unknown time'}.</p>
  <MatchAnalysis data={data}/>
 </section>;
}
